<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card mb-0">
                    <div class="card-body">
                        <div class="row align-items-center">
                            <div class="col-md-6">
                                <div class="d-flex flex-wrap align-items-center justify-content-start">
                                    <h4 class="mr-3">로켓배송 판매장부</h4>
                                    <small>기간별 상품 판매 수익성 분석</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <!-- 390 폭: 줄바꿈 없는 justify-content-end 면 넘친 몫이 왼쪽 밖으로 나가 날짜 앞이 잘린다 → 폰은 왼쪽 붙여 줄바꿈 -->
                                <div class="d-flex flex-wrap align-items-end justify-content-start justify-content-md-end">
                                    <label class="mb-0 mr-2 small">조회기간</label>
                                    <b-form-input v-model="startDate" type="date" class="mr-1" size="sm" style="width: 130px;" />
                                    <span class="mx-1">~</span>
                                    <b-form-input v-model="endDate" type="date" class="mr-2" size="sm" style="width: 130px;" />
                                    <b-button variant="primary ml-1 mr-2" class="text-nowrap" @click="search" :disabled="showspinner" size="sm">
                                        <i class="fas fa-search mr-1"></i> 조회
                                    </b-button>
                                    <b-button variant="info" class="text-nowrap" @click="collectSalesData" :disabled="showspinner" size="sm">
                                        <i class="fas fa-download mr-1"></i> 판매현황 수집
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12" v-if="showspinner">
                <div class="d-flex justify-content-center">
                    <div>
                        <img style="max-width:10%;" :src="require('../../../assets/images/small/loading.gif')">
                        {{ loadingtext }} (화면을 이탈하거나 취소시 데이터가 정상적으로 수집되지 않을 수 있습니다.)
                    </div>
                </div>
            </div>

            <!-- 발주서 수집 멈춤(0건 포함) — 표보다 먼저 크게 알린다(#53) -->
            <div class="col-lg-12" v-if="poCollectWarning">
                <b-alert show variant="danger" class="mb-3" style="font-size: 16px;">
                    <i class="fas fa-exclamation-triangle mr-1"></i>
                    <strong>{{ poCollectWarning }}</strong>
                </b-alert>
            </div>

            <div class="col-lg-12" v-if="showlist">
                <!-- 입고 기록 없이 늘어난 재고(재고조정) — 판매량은 그대로 두고 출처만 따로 보여준다(#53) -->
                <b-alert show variant="warning" class="mb-3" v-if="summary.totalAdjust > 0">
                    <i class="fas fa-info-circle mr-1"></i>
                    입고 기록 없이 재고가 늘어난 양: <strong>{{ summary.totalAdjust.toLocaleString() }}개</strong> (SKU {{ summary.adjustSkuCount.toLocaleString() }}개).
                    반품 입고·쿠팡 재고조정 또는 입고 기록 누락입니다. 그날 판매량이 음수로 보이는 이유이며, 「재고조정」 칸에서 날짜·상품별로 확인할 수 있습니다.
                </b-alert>
                <!-- 7개 요약 카드 — 폰 한 줄 2칸(col-6) · 1440 한 줄 7칸(col-lg) · 맨 col 이면 390 에서 칸당 ≈45px 라 머리 글이 한 자씩 세로 -->
                <div class="card mb-4">
                    <div class="card-body py-3">
                        <div class="row text-center">
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">총공급매출</span>
                                <strong class="text-primary" style="font-size: 20px;">{{ Math.round(summary.totalRevenue).toLocaleString() }}원</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">총마진(GP)</span>
                                <strong :class="summary.totalProfit >= 0 ? 'text-success' : 'text-danger'" style="font-size: 20px;">{{ Math.round(summary.totalProfit).toLocaleString() }}원</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">총매입액</span>
                                <strong class="text-danger" style="font-size: 20px;">{{ Math.round(summary.totalPurchase).toLocaleString() }}원</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">총광고비</span>
                                <strong class="text-warning" style="font-size: 20px;">{{ Math.round(summary.totalAdCost).toLocaleString() }}원</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">총마진율</span>
                                <strong :class="summary.totalMarginRate >= 30 ? 'text-success' : summary.totalMarginRate >= 15 ? 'text-warning' : 'text-danger'" style="font-size: 20px;">{{ Math.round(summary.totalMarginRate) }}%</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">ROAS</span>
                                <strong :class="summary.totalROAS >= 300 ? 'text-success' : summary.totalROAS >= 150 ? 'text-warning' : 'text-danger'" style="font-size: 20px;">{{ Math.round(summary.totalROAS) }}%</strong>
                            </div></div>
                            <div class="col-6 col-md-4 col-lg px-1 mb-3 mb-lg-0"><div class="d-flex flex-column h-100 justify-content-between">
                                <span class="text-muted" style="font-size: 14px; word-break: keep-all;">ROI</span>
                                <strong :class="summary.totalROI >= 30 ? 'text-success' : summary.totalROI >= 10 ? 'text-warning' : 'text-danger'" style="font-size: 20px;">{{ Math.round(summary.totalROI) }}%</strong>
                            </div></div>
                        </div>
                    </div>
                </div>

                <!-- 차트 영역 -->
                <div class="row mb-3" v-if="salesLedgerData.length > 0">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header py-2"><h6 class="card-title mb-0">일별 공급매출 & 순수익 추이</h6></div>
                            <div class="card-body py-2">
                                <ApexChart ref="salesLedgerChart" element="sales-ledger-chart" :chartOption="chartOptions" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="card-header py-2 d-flex justify-content-between align-items-center">
                                <h6 class="card-title mb-0">상품별 파레토 차트 (TOP 30)</h6>
                                <div class="d-flex align-items-center">
                                    <small class="mr-2">{{ productChartMode === 'profit' ? '수익기준' : '매출기준' }}</small>
                                    <b-form-checkbox v-model="productChartMode" switch size="sm" true-value="profit" false-value="revenue"></b-form-checkbox>
                                </div>
                            </div>
                            <div class="card-body py-2">
                                <ApexChart v-if="showProductChart" ref="productChart" element="product-chart" :chartOption="productChartOptions" />
                                <div v-else class="text-center py-5"><div class="spinner-border text-primary" role="status"><span class="sr-only">차트 업데이트 중...</span></div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 테이블 헤더 with Switch -->
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center py-2">
                        <h6 class="card-title mb-0">{{ isProductView ? '상품별' : '일별' }} 판매장부</h6>
                        <div class="d-flex align-items-center">
                            <b-button variant="success" size="sm" @click="isProductView ? downloadProductTableExcel() : downloadDailyTableExcel()" class="mr-3" :disabled="showspinner">
                                <i class="fas fa-file-excel mr-1"></i> 엑셀 다운로드
                            </b-button>
                            <small class="mr-2">상품별 보기</small>
                            <b-form-checkbox v-model="isProductView" switch size="sm" @change="toggleView"></b-form-checkbox>
                        </div>
                    </div>
                </div>

                <!-- 일별 데이터 테이블 -->
                <CDataTable
                    storage-key="rocketSalesLedger.1"
                    v-if="!isProductView"
                    key="daily-table"
                    id="daily"
                    :headers="dailyHeaders"
                    :items="salesLedgerData"
                    v-model="tableSelectedItem"
                    :show-select="false"
                    itemKey="date"
                    :items-per-page="31"
                    :pagination="true"
                    :expandable="false"
                    :fixedColumns="'date'"
                    :headerTooltips="headerTooltips"
                    style="cursor: pointer;"
                >
                    <template v-slot:date="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">{{ item.date }}</div>
                    </template>
                    <template v-slot:일별판매량="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">{{ formatNumber(item.일별판매량) }}개</div>
                    </template>
                    <template v-slot:일별공급매출="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;" class="bg-revenue">
                            <span class="font-weight-bold text-primary">{{ formatNumber(item.일별공급매출) }}원</span>
                        </div>
                    </template>
                    <template v-slot:일별매입원가="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;" class="bg-cost">{{ formatNumber(item.일별매입원가) }}원</div>
                    </template>
                    <template v-slot:일별마진="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">
                            <span :class="item.일별마진 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.일별마진) }}원</span>
                        </div>
                    </template>
                    <template v-slot:일별광고비="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;" class="bg-cost">{{ formatNumber(item.일별광고비) }}원</div>
                    </template>
                    <template v-slot:일별순수익="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">
                            <span :class="item.일별순수익 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.일별순수익) }}원</span>
                        </div>
                    </template>
                    <template v-slot:일별자연판매량="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">{{ formatNumber(item.일별자연판매량) }}개</div>
                    </template>
                    <template v-slot:일별광고판매량="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">{{ formatNumber(item.일별광고판매량) }}개</div>
                    </template>
                    <template v-slot:일별ROAS="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">
                            {{ (item.일별ROAS && item.일별ROAS > 0) ? (item.일별ROAS * 100).toFixed(1) + '%' : '-' }}
                        </div>
                    </template>
                    <template v-slot:일별ROI="{item}">
                        <div @click="showDateDetail(item)" style="cursor: pointer;">
                            <span v-if="item.일별ROI && item.일별ROI !== 0" :class="item.일별ROI >= 30 ? 'text-success font-weight-bold' : item.일별ROI >= 10 ? 'text-warning' : 'text-danger'">
                                {{ item.일별ROI.toFixed(1) }}%
                            </span>
                            <span v-else>-</span>
                        </div>
                    </template>
                </CDataTable>

                <!-- 상품별 데이터 테이블 -->
                <CDataTable
                    storage-key="rocketSalesLedger.2"
                    v-if="isProductView"
                    key="product-table"
                    id="product"
                    :headers="productHeaders"
                    :items="productViewData"
                    v-model="tableSelectedItem"
                    :show-select="false"
                    itemKey="vendorItemId"
                    :items-per-page="50"
                    :pagination="true"
                    :expandable="false"
                    :fixedColumns="'상품명'"
                    :headerTooltips="headerTooltips"
                    style="cursor: pointer;"
                >
                    <template v-slot:썸네일="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <img :src="item.썸네일" class="img-fluid rounded avatar-40" alt="image" />
                        </div>
                    </template>
                    <template v-slot:상품명="{item}">
                        <div @click="showProductDetail(item)" style="max-width: 200px; cursor: pointer;">
                            <div class="text-truncate font-weight-bold" :title="item.상품명">{{ item.상품명 }}</div>
                            <div class="text-truncate text-muted small" :title="item.vendorItemId">ID: {{ item.vendorItemId }}</div>
                        </div>
                    </template>
                    <template v-slot:판매량="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">{{ formatNumber(item.판매량) }}개</div>
                    </template>
                    <template v-slot:공급매출="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;" class="bg-revenue">
                            <span class="font-weight-bold text-primary">{{ formatNumber(item.공급매출) }}원</span>
                        </div>
                    </template>
                    <template v-slot:매입원가="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;" class="bg-cost">{{ formatNumber(item.매입원가) }}원</div>
                    </template>
                    <template v-slot:마진="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span :class="item.마진 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.마진) }}원</span>
                        </div>
                    </template>
                    <template v-slot:마진율="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span :class="item.마진율 >= 30 ? 'text-success font-weight-bold' : item.마진율 >= 15 ? 'text-warning' : 'text-danger'">{{ item.마진율.toFixed(1) }}%</span>
                        </div>
                    </template>
                    <template v-slot:광고비="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;" class="bg-cost">{{ formatNumber(item.광고비) }}원</div>
                    </template>
                    <template v-slot:순수익="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span :class="item.순수익 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.순수익) }}원</span>
                        </div>
                    </template>
                    <template v-slot:자연판매량="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">{{ formatNumber(item.자연판매량 || 0) }}개</div>
                    </template>
                    <template v-slot:광고판매량="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">{{ formatNumber(item.광고판매량 || 0) }}개</div>
                    </template>
                    <template v-slot:광고매출="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span :class="(item.광고매출 || 0) >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(Math.round(item.광고매출 || 0)) }}원</span>
                        </div>
                    </template>
                    <template v-slot:광고순수익="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span :class="(item.광고순수익 || 0) >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(Math.round(item.광고순수익 || 0)) }}원</span>
                        </div>
                    </template>
                    <template v-slot:ROAS="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            {{ (item.ROAS !== null && item.ROAS !== undefined) ? (item.ROAS * 100).toFixed(1) + '%' : '-' }}
                        </div>
                    </template>
                    <template v-slot:광고ROI="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            {{ (item.광고ROI !== null && item.광고ROI !== undefined) ? (item.광고ROI * 100).toFixed(1) + '%' : '-' }}
                        </div>
                    </template>
                    <template v-slot:ROI="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">
                            <span v-if="item.ROI !== null && item.ROI !== undefined" :class="item.ROI >= 30 ? 'text-success font-weight-bold' : item.ROI >= 10 ? 'text-warning' : 'text-danger'">{{ item.ROI.toFixed(1) }}%</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                    <template v-slot:재고="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">{{ formatNumber(item.재고 || 0) }}개</div>
                    </template>
                    <template v-slot:입고="{item}">
                        <div @click="showProductDetail(item)" style="cursor: pointer;">{{ formatNumber(item.입고 || 0) }}개</div>
                    </template>
                </CDataTable>

                <!-- 상세 정보 모달 -->
                <b-modal
                    v-model="showModal"
                    :title="modalTitle"
                    size="xl"
                    hide-footer
                    scrollable
                    modal-class="rocket-sales-ledger-modal"
                    @shown="forceModalStyle"
                >
                    <!-- 모달 상단 차트 영역 -->
                    <div class="mb-3">
                        <div v-if="!isProductView" class="card">
                            <div class="card-header py-2"><h6 class="card-title mb-0">상품별 파레토 차트</h6></div>
                            <div class="card-body py-2 modal-chart-container">
                                <ApexChart v-if="showModalChart" ref="modalChart" element="modal-chart" :chartOption="modalChartOptions" />
                                <div v-else class="text-center py-3"><div class="spinner-border text-primary" role="status"><span class="sr-only">차트 로딩 중...</span></div></div>
                            </div>
                        </div>
                        <div v-else class="card">
                            <div class="card-header py-2 d-flex justify-content-between align-items-center">
                                <h6 class="card-title mb-0">일자별 지표</h6>
                                <div class="d-flex align-items-center">
                                    <span class="mr-2 small" :class="dailyChartMode === 'amount' ? 'font-weight-bold' : 'text-muted'">금액</span>
                                    <b-form-checkbox v-model="dailyChartMode" switch true-value="quantity" false-value="amount" @change="updateDailyChart" class="mb-0" />
                                    <span class="ml-2 small" :class="dailyChartMode === 'quantity' ? 'font-weight-bold' : 'text-muted'">수량</span>
                                </div>
                            </div>
                            <div class="card-body py-2 modal-chart-container">
                                <ApexChart v-if="showModalChart" ref="modalChart" element="modal-chart" :chartOption="modalChartOptions" />
                                <div v-else class="text-center py-3"><div class="spinner-border text-primary" role="status"><span class="sr-only">차트 로딩 중...</span></div></div>
                            </div>
                        </div>
                    </div>

                    <!-- 모달 테이블 엑셀 다운로드 버튼 -->
                    <div class="mb-3 text-right">
                        <b-button variant="success" size="sm" @click="downloadModalTableExcel()" :disabled="showspinner">
                            <i class="fas fa-file-excel mr-1"></i> 엑셀 다운로드
                        </b-button>
                    </div>

                    <CDataTable
                        storage-key="rocketSalesLedger.3"
                        :headers="modalHeaders"
                        :items="modalData"
                        :show-select="false"
                        :items-per-page="20"
                        :pagination="true"
                        itemKey="uniqueKey"
                        :fixedColumns="modalFixedColumns"
                        :headerTooltips="headerTooltips"
                        class="table-sm"
                    >
                        <!-- 모달: 상품별 슬롯 (일별 클릭 시) -->
                        <template v-slot:썸네일="{item}">
                            <img :src="item.썸네일" class="img-fluid rounded avatar-40" alt="image" />
                        </template>
                        <template v-slot:상품명="{item}">
                            <div style="max-width: 200px;">
                                <div class="text-truncate font-weight-bold" :title="item.상품명">{{ item.상품명 }}</div>
                                <div class="text-truncate text-muted small" :title="item.vendorItemId">ID: {{ item.vendorItemId }}</div>
                            </div>
                        </template>
                        <template v-slot:판매량="{item}">{{ formatNumber(item.판매량) }}개</template>
                        <template v-slot:공급매출="{item}"><div class="bg-revenue">{{ formatNumber(item.공급매출) }}원</div></template>
                        <template v-slot:매입원가="{item}"><div class="bg-cost">{{ formatNumber(item.매입원가) }}원</div></template>
                        <template v-slot:마진="{item}">
                            <span :class="item.마진 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.마진) }}원</span>
                        </template>
                        <template v-slot:마진율="{item}">
                            <span :class="item.마진율 >= 30 ? 'text-success font-weight-bold' : item.마진율 >= 15 ? 'text-warning' : 'text-danger'">{{ item.마진율.toFixed(1) }}%</span>
                        </template>
                        <template v-slot:광고비="{item}"><div class="bg-cost">{{ formatNumber(item.광고비) }}원</div></template>
                        <template v-slot:순수익="{item}">
                            <span :class="item.순수익 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.순수익) }}원</span>
                        </template>
                        <template v-slot:자연판매량="{item}">{{ formatNumber(item.자연판매량 || 0) }}개</template>
                        <template v-slot:광고판매량="{item}">{{ formatNumber(item.광고판매량 || 0) }}개</template>
                        <template v-slot:광고매출="{item}">
                            <span :class="(item.광고매출 || 0) >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(Math.round(item.광고매출 || 0)) }}원</span>
                        </template>
                        <template v-slot:광고순수익="{item}">
                            <span :class="(item.광고순수익 || 0) >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(Math.round(item.광고순수익 || 0)) }}원</span>
                        </template>
                        <template v-slot:ROAS="{item}">{{ (item.ROAS !== null && item.ROAS !== undefined) ? (item.ROAS * 100).toFixed(1) + '%' : '-' }}</template>
                        <template v-slot:광고ROI="{item}">{{ (item.광고ROI !== null && item.광고ROI !== undefined) ? (item.광고ROI * 100).toFixed(1) + '%' : '-' }}</template>
                        <template v-slot:ROI="{item}">
                            <span v-if="item.ROI !== null && item.ROI !== undefined" :class="item.ROI >= 30 ? 'text-success font-weight-bold' : item.ROI >= 10 ? 'text-warning' : 'text-danger'">{{ item.ROI.toFixed(1) }}%</span>
                            <span v-else>-</span>
                        </template>
                        <template v-slot:재고="{item}">{{ formatNumber(item.재고 || 0) }}개</template>
                        <template v-slot:입고="{item}">{{ formatNumber(item.입고 || 0) }}개</template>
                        <!-- 모달: 일별 슬롯 (상품 클릭 시) -->
                        <template v-slot:일별판매량="{item}">{{ formatNumber(item.일별판매량) }}개</template>
                        <template v-slot:일별공급매출="{item}"><div class="bg-revenue">{{ formatNumber(item.일별공급매출) }}원</div></template>
                        <template v-slot:일별매입원가="{item}"><div class="bg-cost">{{ formatNumber(item.일별매입원가) }}원</div></template>
                        <template v-slot:일별마진="{item}">
                            <span :class="item.일별마진 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.일별마진) }}원</span>
                        </template>
                        <template v-slot:일별광고비="{item}"><div class="bg-cost">{{ formatNumber(item.일별광고비) }}원</div></template>
                        <template v-slot:일별순수익="{item}">
                            <span :class="item.일별순수익 >= 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">{{ formatNumber(item.일별순수익) }}원</span>
                        </template>
                        <template v-slot:일별자연판매량="{item}">{{ formatNumber(item.일별자연판매량) }}개</template>
                        <template v-slot:일별광고판매량="{item}">{{ formatNumber(item.일별광고판매량) }}개</template>
                        <template v-slot:일별ROAS="{item}">{{ (item.일별ROAS && item.일별ROAS > 0) ? (item.일별ROAS * 100).toFixed(1) + '%' : '-' }}</template>
                        <template v-slot:일별ROI="{item}">
                            <span v-if="item.일별ROI && item.일별ROI !== 0" :class="item.일별ROI >= 30 ? 'text-success font-weight-bold' : item.일별ROI >= 10 ? 'text-warning' : 'text-danger'">{{ item.일별ROI.toFixed(1) }}%</span>
                            <span v-else>-</span>
                        </template>
                    </CDataTable>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import CDataTable from '@/components/common/CDataTable'
import ApexChart from '@/components/charts/ApexChart'

export default {
    name: 'RocketSalesLedger',
    components: {
        CDataTable,
        ApexChart
    },
    data() {
        return {
            title: '로켓배송 판매장부',
            desc1: '기간별 상품 판매 수익성 분석',
            desc2: '로켓배송 전용 지표로 상품별 수익성을 한눈에 확인하세요',

            showlist: false,
            showspinner: false,
            loadingtext: '데이터 로딩 중...',

            // 조회 기간
            startDate: '',
            endDate: '',

            // 테이블 데이터
            salesLedgerData: [], // 일별 보기 데이터 (V3)
            productViewData: [], // 상품별 보기 데이터
            rocketProductData: [], // rocketProductManagement 데이터
            salesData: [], // sales 데이터
            supplyData: [], // supply 데이터
            adData: [], // 광고데이터
            tableSelectedItem: [],

            // 보기 모드 및 모달
            isProductView: false, // 상품별 보기 switch
            productChartMode: 'profit', // 상품별 차트 모드
            dailyChartMode: 'amount', // 일별 차트 모드
            showModal: false,
            modalTitle: '',
            modalData: [],
            modalHeaders: [],
            showModalChart: false,
            modalChartOptions: {},

            // 요약 데이터
            summary: {
                totalRevenue: 0,
                totalProfit: 0,
                totalPurchase: 0,
                totalAdCost: 0,
                totalMarginRate: 0,
                totalROAS: 0,
                totalROI: 0,
                totalAdjust: 0,
                adjustSkuCount: 0
            },

            // 발주서 수집 현황 경고 문구 (빈 문자열이면 숨김)
            poCollectWarning: '',

            // 차트 옵션
            chartOptions: {},
            productChartOptions: {},
            showProductChart: true,

            // 헤더 툴팁 정의 (로켓배송 전용)
            headerTooltips: {
                'date': '매출 인식일 기준입니다',
                '썸네일': '상품 이미지입니다',
                '상품명': '상품명입니다',
                '일별판매량': '해당 일자 총 판매 수량입니다 (재고델타 기반)',
                '일별공급매출': '해당 일자 공급가 × 판매량입니다',
                '일별매입원가': '해당 일자 매입가 × 판매량입니다',
                '일별마진': '해당 일자 (공급가-매입가)×10/11×판매량입니다',
                '일별광고비': '해당 일자 광고비 (쿠팡 광고 보고서 값 그대로 · 부가세 제외)입니다',
                '일별순수익': '해당 일자 마진 - 광고비입니다',
                '일별자연판매량': '광고를 통하지 않은 자연 판매 수량입니다',
                '일별광고판매량': '광고를 통한 판매 수량입니다',
                '일별ROAS': '광고 대비 매출 비율입니다',
                '일별ROI': '매입(투자) 대비 수익률입니다',
                '판매량': '해당 기간 총 판매 수량입니다',
                '공급매출': '공급가 × 판매량 합계입니다',
                '매입원가': '매입가 × 판매량 합계입니다',
                '마진': '(공급가-매입가)×10/11×판매량 합계입니다',
                '마진율': '마진/공급매출×100 입니다',
                '광고비': '광고비 합계입니다',
                '순수익': '총마진 - 총광고비입니다',
                '자연판매량': '광고를 통하지 않은 자연 판매 수량입니다',
                '광고판매량': '광고를 통한 판매 수량입니다',
                '광고매출': '광고판매량 × 단위마진 (광고비 차감 전)',
                '광고순수익': '광고매출 - 광고비 (광고비 차감 후 순수익)',
                'ROAS': '광고 대비 매출 비율입니다',
                '광고ROI': '광고비 대비 광고매출 비율입니다',
                'ROI': '매입(투자) 대비 수익률입니다',
                '재고': '최종일 기준 쿠팡 재고 수량입니다',
                '입고': '해당 기간 입고 수량 합계입니다',
                '일별재고조정': '입고 기록 없이 재고가 늘어난 수량입니다 (반품·쿠팡 재고조정·입고 기록 누락). 판매량이 음수인 만큼입니다',
                '재고조정': '입고 기록 없이 재고가 늘어난 수량 합계입니다 (반품·쿠팡 재고조정·입고 기록 누락)'
            },

            // 일별 테이블 헤더
            dailyHeaders: [
                { text: '날짜', value: 'date', align: 'center', width: 120, isSlot: true },
                { text: '판매량', value: '일별판매량', align: 'right', width: 100, isSlot: true },
                { text: '공급매출', value: '일별공급매출', align: 'right', width: 120, isSlot: true },
                { text: '매입원가', value: '일별매입원가', align: 'right', width: 120, isSlot: true },
                { text: '마진', value: '일별마진', align: 'right', width: 120, isSlot: true },
                { text: '광고비', value: '일별광고비', align: 'right', width: 100, isSlot: true },
                { text: '순수익', value: '일별순수익', align: 'right', width: 120, isSlot: true },
                { text: '자연판매량', value: '일별자연판매량', align: 'right', width: 100, isSlot: true },
                { text: '광고판매량', value: '일별광고판매량', align: 'right', width: 100, isSlot: true },
                { text: 'ROAS', value: '일별ROAS', align: 'right', width: 80, isSlot: true },
                { text: 'ROI', value: '일별ROI', align: 'right', width: 80, isSlot: true },
                { text: '재고조정', value: '일별재고조정', align: 'right', width: 90, isSlot: false }
            ],

            // 상품별 테이블 헤더
            productHeaders: [
                { text: '썸네일', value: '썸네일', align: 'center', width: 80, isSlot: true },
                { text: '상품명', value: '상품명', align: 'left', width: 250, isSlot: true },
                { text: '판매량', value: '판매량', align: 'right', width: 100, isSlot: true },
                { text: '공급매출', value: '공급매출', align: 'right', width: 120, isSlot: true },
                { text: '매입원가', value: '매입원가', align: 'right', width: 120, isSlot: true },
                { text: '마진', value: '마진', align: 'right', width: 120, isSlot: true },
                { text: '마진율', value: '마진율', align: 'right', width: 80, isSlot: true },
                { text: '광고비', value: '광고비', align: 'right', width: 100, isSlot: true },
                { text: '순수익', value: '순수익', align: 'right', width: 120, isSlot: true },
                { text: '자연판매량', value: '자연판매량', align: 'right', width: 100, isSlot: true },
                { text: '광고판매량', value: '광고판매량', align: 'right', width: 100, isSlot: true },
                { text: '광고매출', value: '광고매출', align: 'right', width: 120, isSlot: true },
                { text: '광고순수익', value: '광고순수익', align: 'right', width: 120, isSlot: true },
                { text: 'ROAS', value: 'ROAS', align: 'right', width: 80, isSlot: true },
                { text: '광고ROI', value: '광고ROI', align: 'right', width: 80, isSlot: true },
                { text: 'ROI', value: 'ROI', align: 'right', width: 80, isSlot: true },
                { text: '재고', value: '재고', align: 'right', width: 80, isSlot: true },
                { text: '입고', value: '입고', align: 'right', width: 80, isSlot: true },
                { text: '재고조정', value: '재고조정', align: 'right', width: 90, isSlot: false }
            ]
        }
    },
    computed: {
        // 모달의 고정 컬럼 결정
        modalFixedColumns() {
            if (this.isProductView) {
                // 상품별 보기에서 일별 상세 모달: 날짜 고정
                return 'date';
            } else {
                // 일별 보기에서 상품별 상세 모달: 상품명 고정
                return '상품명';
            }
        }
    },
    async mounted() {
        // 기본 조회 기간 설정 (어제까지 30일)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);

        const thirtyDaysAgo = new Date(yesterday);
        thirtyDaysAgo.setDate(yesterday.getDate() - 29);

        this.endDate = yesterday.toISOString().split('T')[0];
        this.startDate = thirtyDaysAgo.toISOString().split('T')[0];

        console.log(`로켓배송 판매장부 기본 조회 기간: ${this.startDate} ~ ${this.endDate}`);

        // 메시지 이벤트 핸들러 등록 (growthSalesLedger 패턴)
        this.messageEventHandler = async (event) => {
            // 수집 완료 메시지
            if (event.data.type === 'manualCollectComplete' && event.data.itemKey === 'rocketDeliverySales') {
                this.showspinner = false;
                this.showlist = true;
                if (event.data.success === false) {
                    alert(event.data.error || '판매현황 수집에 실패했습니다.');
                    return;
                }
                this.search();
            }
            // 진행 상태 표시
            if (event.data.type === 'autoCollectStatus') {
                this.showspinner = true;
                this.loadingtext = event.data.message;
            }
        };

        window.addEventListener('message', this.messageEventHandler);

        // 발주서 수집 현황은 표와 따로 — 실패해도 화면은 그대로 뜬다
        this.loadPoCollectStatus();

        // 초기 데이터 로드
        await this.loadBaseData();
    },
    beforeDestroy() {
        if (this.messageEventHandler) {
            window.removeEventListener('message', this.messageEventHandler);
        }
    },
    methods: {
        // 기본 데이터 로드
        async loadBaseData() {
            try {
                this.showspinner = true;
                this.loadingtext = '기본 데이터 로딩 중...';

                // rocketProductManagement 데이터 로드
                const productResult = await axios.post('/api/product/getRocketProductData', {
                    companyid: this.$store.state.user.companyid
                });

                if (productResult.data.success) {
                    this.rocketProductData = productResult.data.data || [];
                    console.log('로켓배송 상품 데이터 로드 완료:', this.rocketProductData.length);

                    // 첫 번째 상품의 구조 확인
                    if (this.rocketProductData.length > 0) {
                        console.log('첫 번째 상품 데이터 구조:', this.rocketProductData[0]);
                        console.log('사용 가능한 필드들:', Object.keys(this.rocketProductData[0]));
                    }
                } else {
                    console.error('로켓배송 상품 데이터 로드 실패:', productResult.data);
                    this.rocketProductData = [];
                }

                this.showspinner = false;
            } catch (error) {
                console.error('기본 데이터 로드 실패:', error);
                this.rocketProductData = [];
                this.showspinner = false;
            }
        },

        // 발주서 수집 현황 — 대시보드 수집 현황과 같은 판정(/api/dashboard/collect 의 rocket.polist)을 쓴다.
        // 발주서 수집이 0건으로 조용히 끝나면 멈춘 줄 모른다. 진짜 발주가 없는 고객도 있으므로 «실패»로 단정하지 않고 «확인 필요»로 알린다(#53)
        async loadPoCollectStatus() {
            try {
                const res = await axios.post('/api/dashboard/collect', {});
                if (!res.data || res.data.res !== 'success') {
                    console.error('발주서 수집 현황 응답 이상(경고 표시 건너뜀):', res.data);
                    return;
                }
                const email = this.$store.state.user && this.$store.state.user.email;
                const state = ((res.data.collect || {})[email] || {})['rocket.polist'];
                const at = ((res.data.lastAt || {})[email] || {})['rocket.polist'] || {};
                const svc = (res.data.services || []).find(s => s.key === 'rocket.polist') || {};
                this.poCollectWarning = this.poCollectWarningText(state, at, svc.staleDays);
            } catch (error) {
                console.error('발주서 수집 현황 조회 실패:', error);
            }
        },

        poCollectWarningText(state, at, staleDays) {
            if (state === 'none') {
                return '로켓배송 발주서가 한 건도 수집되지 않았습니다(0건·확인 필요). 발주가 정말 없었는지, 발주서 수집이 되고 있는지 확인해 주세요.';
            }
            if (state === 'collected' && at && at.stale) {
                return `로켓배송 발주서가 ${at.date} 이후 ${staleDays || 7}일 넘게 새로 수집되지 않았습니다(최근 수집 0건·확인 필요). 발주가 정말 없었는지, 수집이 멈췄는지 확인해 주세요.`;
            }
            return '';
        },

        // 판매현황 수집 (manualCollect 방식 - growthSalesLedger 패턴)
        async collectSalesData() {
            console.log('로켓배송 판매현황 수집 시작');

            if (!this.startDate || !this.endDate) {
                alert('조회 기간을 설정해 주세요.');
                return;
            }

            // 오늘 날짜 데이터 존재 여부 확인 (공급관리에서 이미 수집했을 수 있음)
            try {
                // toISOString 은 UTC 라 오전 9시 전엔 어제가 된다 — 로컬(KST) 날짜로. channel:'rocket' = Sales 기준(#64)
                const now = new Date();
                const today = `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}-${('0' + now.getDate()).slice(-2)}`;
                const checkResult = await axios.post('/api/growth/checkDailySalesExists', { date: today, channel: 'rocket' });
                if (checkResult.data.res === 'success' && checkResult.data.exists) {
                    if (!confirm('오늘자 데이터가 이미 수집되어 있습니다.\n(공급관리 또는 이전 수집)\n다시 수집하시겠습니까?')) {
                        return;
                    }
                }
            } catch (error) {
                console.error('수집 여부 확인 실패:', error);
            }

            window.postMessage({
                greeting: "manualCollect",
                itemKey: "rocketDeliverySales",
                companyid: this.$store.state.user.companyid,
                suppliercode: this.$store.state.user.suppliercode,
                options: {
                    dateRange: {
                        startDate: this.startDate,
                        endDate: this.endDate
                    }
                }
            }, "*");

            this.showspinner = true;
            this.showlist = false;
            this.loadingtext = '로켓배송 판매현황 수집 중...';
        },

        // 판매링크에서 vendorItemId 추출 (rocketProductManagement.vue와 동일한 로직)
        extractVendorItemId(link) {
            if (!link) return '';
            const match = link.match(/vendorItemId=(\d+)/);
            return match ? match[1] : '';
        },

        // 광고 중복 제거 — 광고비가 두 배로 잡히던 원인.
        //
        // 광고데이터는 (업체코드, 옵션ID, 날짜, 광고구분) 하나당 한 건이어야 한다. 그런데
        // 2026-06-16 에 날짜 저장형식을 바꾸면서 과거분을 다시 받아, 같은 실적이 옛 형식과
        // 새 형식 두 건으로 남은 구간이 있다(2026-02-06~06-15). 서버가 날짜를 새 형식으로
        // 맞춰 내려주므로 화면에서는 둘이 구분되지 않은 채 둘 다 더해졌다.
        // ⇒ 실측 44개사, 광고비 합계의 7.86%(1.166억)가 부풀려져 있었다.
        //
        // 서버(getRocketAdData)에서도 같은 기준으로 거르지만, 여기서 한 번 더 접어 두면
        // 예전 응답을 물고 있는 경우에도 숫자가 어긋나지 않는다. 중복이 없으면 아무 일도 없다.
        // 승자는 나중에 적재된 것(created_at 최대) — 서버 쪽 rocketAdNewer 와 같은 결과다.
        dedupAdData(ads) {
            if (!Array.isArray(ads)) return [];
            const best = new Map();
            for (const ad of ads) {
                const key = `${ad.suppliercode}|${ad.vendorItemId}|${ad.date}|${ad.adType}`;
                const prev = best.get(key);
                if (!prev || new Date(ad.created_at || 0) > new Date(prev.created_at || 0)) {
                    best.set(key, ad);
                }
            }
            return Array.from(best.values());
        },

        // fromExclusive 다음날 ~ toInclusive 까지의 날짜 배열 ('YYYY-MM-DD')
        // 재고 스냅샷(Sales)이 매일 있지 않아 두 스냅샷 사이가 벌어질 때 그 구간을 훑기 위한 것
        dateRangeAfter(fromExclusive, toInclusive) {
            const dates = [];
            const cursor = new Date(fromExclusive + 'T00:00:00Z');
            const end = new Date(toInclusive + 'T00:00:00Z');
            if (isNaN(cursor.getTime()) || isNaN(end.getTime())) return [toInclusive];
            cursor.setUTCDate(cursor.getUTCDate() + 1);
            while (cursor <= end && dates.length < 400) {
                dates.push(cursor.toISOString().slice(0, 10));
                cursor.setUTCDate(cursor.getUTCDate() + 1);
            }
            return dates;
        },

        // 검색/조회 (salesstatus.vue와 동일한 방식)
        async search() {
            console.log('로켓배송 판매장부 조회 시작');

            if (!this.startDate || !this.endDate) {
                alert('조회 기간을 설정해 주세요.');
                return;
            }

            try {
                this.showspinner = true;
                this.loadingtext = '로켓배송 판매장부 데이터 조회 중...';

                // salesstatus.vue와 동일한 방식으로 데이터 조회
                const salesResult = await axios.post('/api/listsales', {
                    companyid: this.$store.state.user.companyid,
                    start: this.startDate,
                    end: this.endDate
                });

                console.log('Sales 데이터 조회 완료:', salesResult.data.sales?.length || 0);
                this.$store.commit('salesupdate', salesResult.data.sales);

                const supplyResult = await axios.post('/api/listsales/supplylist', {
                    companyid: this.$store.state.user.companyid,
                    start: this.startDate,
                    end: this.endDate
                });

                console.log('Supply 데이터 조회 완료:', supplyResult.data.supply?.length || 0);
                this.$store.commit('supplyupdate', supplyResult.data.supply);

                // 광고데이터 조회
                const adResult = await axios.post('/api/getRocketAdData', {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    suppliercode: this.$store.state.user.suppliercode
                });

                this.adData = adResult.data.success ? adResult.data.data : [];
                console.log('광고 데이터 조회 완료:', this.adData.length);

                console.log('데이터 조회 완료:', {
                    products: this.rocketProductData.length,
                    sales: this.$store.state.sales?.length || 0,
                    supply: this.$store.state.supply?.length || 0,
                    ads: this.adData.length
                });

                // 판매장부 데이터 처리 (V3: 일별 그룹)
                this.processRocketSalesLedgerV3();

                this.showlist = true;
                this.showspinner = false;
            } catch (error) {
                console.error('로켓배송 판매장부 조회 실패:', error);
                alert('데이터 조회에 실패했습니다: ' + error.message);
                this.showspinner = false;
            }
        },

        // 로켓배송 판매장부 V3 (일별 그룹 → 상품별 집계, growthSalesLedger 패턴)
        processRocketSalesLedgerV3() {
            console.log('=== processRocketSalesLedgerV3 시작 ===');

            const salesData = this.$store.state.sales || [];
            const supplyData = this.$store.state.supply || [];
            const productData = this.rocketProductData;

            console.log('판매 데이터:', salesData.length, '일');
            console.log('입고 데이터:', supplyData.length, '일');
            console.log('상품 데이터:', productData.length, '개');

            if (salesData.length < 2) {
                console.log('판매 데이터가 2일 미만 - 일별 판매량 계산 불가');
                this.salesLedgerData = [];
                this.productViewData = [];
                return;
            }

            // 날짜순 정렬
            const sortedDates = [...new Set(salesData.map(s => s.date))].sort();
            console.log('조회 기간:', sortedDates[0], '~', sortedDates[sortedDates.length - 1]);

            // 인덱싱: 날짜별 판매/입고/광고 맵
            const salesByDate = {};
            salesData.forEach(s => { salesByDate[s.date] = s; });

            const supplyByDate = {};
            supplyData.forEach(s => { supplyByDate[s.importdate] = s; });

            const adByDateVendor = {};
            this.dedupAdData(this.adData).forEach(ad => {
                const key = `${ad.date}_${ad.vendorItemId}`;
                if (!adByDateVendor[key]) adByDateVendor[key] = [];
                adByDateVendor[key].push(ad);
            });

            // SKU → 상품정보 맵
            const productMap = {};
            productData.forEach(p => {
                const skuId = p["SKU ID"];
                if (skuId) productMap[skuId] = p;
            });

            // 일별 데이터 생성 (두 번째 날부터 - 전날 재고와 비교)
            const dailyGrouped = {};

            for (let i = 1; i < sortedDates.length; i++) {
                const prevDate = sortedDates[i - 1];
                const currDate = sortedDates[i];
                const prevSales = salesByDate[prevDate];
                const currSales = salesByDate[currDate];

                if (!prevSales || !currSales || !currSales.판매세부내역) continue;

                dailyGrouped[currDate] = {
                    date: currDate, products: [],
                    일별판매량: 0, 일별공급매출: 0, 일별매입원가: 0,
                    일별마진: 0, 일별광고비: 0, 일별순수익: 0,
                    일별자연판매량: 0, 일별광고판매량: 0,
                    일별ROAS: 0, 일별ROI: 0, 일별재고: 0, 일별입고: 0, 일별재고조정: 0
                };

                // 재고 스냅샷(Sales)이 매일 있지 않아 prevDate~currDate 가 벌어질 수 있다.
                // 판매량이 그 구간의 누적이므로 입고·광고비도 같은 구간으로 집계해야 짝이 맞는다.
                const 구간날짜 = this.dateRangeAfter(prevDate, currDate);

                // 현재 날짜의 SKU별 처리
                currSales.판매세부내역.forEach(detail => {
                    const skuId = detail.sk;
                    const productInfo = productMap[skuId];
                    if (!productInfo) return;

                    // 전날/당일 재고
                    const prevDetail = prevSales.판매세부내역?.find(d => d.sk === skuId);
                    const prevStock = prevDetail ? (prevDetail.s || 0) : 0;
                    const currStock = detail.s || 0;
                    const 판매가 = detail.p || 0;

                    // 구간 입고량 (prevDate 다음날 ~ currDate)
                    let 입고량 = 0;
                    for (const supplyDate of 구간날짜) {
                        const supplyDay = supplyByDate[supplyDate];
                        if (!supplyDay?.importlist) continue;
                        for (const item of supplyDay.importlist) {
                            if (item.sku번호?.toString() !== skuId.toString()) continue;
                            // 반출은 입고가 아니라 출고라 더하면 부호가 반대가 된다
                            if (item.구분 === '반출') continue;
                            // 같은 날 같은 SKU가 여러 건 입고되므로 전부 더한다 (find 로 첫 건만 세면 누락)
                            // 수량이 "3,840" 처럼 콤마 포함 문자열로 오는 경우가 있어 제거 후 파싱한다
                            입고량 += parseInt(String(item.수량 ?? 0).replace(/,/g, ''), 10) || 0;
                        }
                    }

                    // 구간 판매량 = 전날재고 + 구간입고 - 당일재고
                    const 판매량 = prevStock + 입고량 - currStock;
                    // 입고 기록 없이 재고가 늘어난 양(반품·쿠팡 재고조정·입고 기록 누락) = 음수 판매량의 크기.
                    // 판매량은 덮지 않는다(반품 상쇄용 음수 행 유지) — 출처만 따로 보여준다(#53)
                    const 재고조정 = 판매량 < 0 ? -판매량 : 0;

                    // 상품 가격 정보
                    const 공급가 = productInfo.공급가 || productInfo.매입가 || productInfo.현재매입가 || 0;
                    const 매입가 = productInfo.latestImportPrice || productInfo.매입원가 || 0;
                    const vendorItemId = productInfo.vendorItemId ||
                                        productInfo.옵션ID ||
                                        this.extractVendorItemId(productInfo.판매링크);

                    // 광고 데이터 (detail 기반 전환 분석)
                    // currDate 하루만 조인하면 스냅샷이 없는 날의 광고비가 통째로 버려지므로 구간 전체를 합산한다
                    const dayAds = [];
                    for (const adDate of 구간날짜) {
                        const ads = adByDateVendor[`${adDate}_${vendorItemId}`];
                        if (ads) dayAds.push(...ads);
                    }
                    let 광고비 = 0, 직접광고판매량 = 0, 기여받은판매량 = 0;

                    dayAds.forEach(ad => {
                        광고비 += ad.cost || 0;
                        if (ad.detail && Array.isArray(ad.detail)) {
                            ad.detail.forEach(conv => {
                                if (String(conv.vendorItemId) === String(vendorItemId)) {
                                    if (String(ad.vendorItemId) === String(vendorItemId)) {
                                        직접광고판매량 += conv.units || 0;
                                    } else {
                                        기여받은판매량 += conv.units || 0;
                                    }
                                }
                            });
                        }
                    });

                    const 광고판매량 = 직접광고판매량 + 기여받은판매량;

                    // 그 날 아무 일도 없던 상품만 건너뛴다(재고 변동 0 + 입고 0 + 광고비 0).
                    //
                    // 판매량이 **음수인 행은 버리지 않는다.** 판매량 = 전날재고 + 입고 − 당일재고 이므로
                    // 반품이 들어와 재고가 늘면 음수가 된다. 예전 조건(`판매량 <= 0`)은 "변동 없음(0)"과
                    // "반품 유입(음수)"을 같이 걸러서, +10 인 날은 다 더해지고 −5 인 날만 빠졌다.
                    // 상쇄가 안 되니 총판매량이 한쪽으로만 부풀었다
                    // (실측 GEUMSUNG: 재고 수지 5,511 vs 화면 5,946, +435 = 7.9%).
                    if (판매량 === 0 && 입고량 <= 0 && 광고비 <= 0) return;

                    // 매출/마진 계산
                    const 공급매출 = 판매량 * 공급가;
                    const 매입원가 = 판매량 * 매입가;
                    const 단위마진 = (공급가 - 매입가) * 10 / 11;
                    const 마진 = 단위마진 * 판매량;
                    const 마진율 = 공급가 > 0 ? (단위마진 / 공급가 * 100) : 0;

                    const 자연판매량 = Math.max(0, 판매량 - 광고판매량);
                    const 순수익 = 마진 - 광고비;
                    const ROAS = 광고비 > 0 ? (광고판매량 * 공급가 / 광고비) : 0;
                    const ROI = 매입원가 > 0 ? (순수익 / (매입원가 * 10 / 11) * 100) : 0;

                    const productMetrics = {
                        vendorItemId, SKUID: skuId,
                        상품명: productInfo.상품명 || '', 썸네일: productInfo.썸네일 || '',
                        판매량, 공급매출, 매입원가, 단위마진, 마진,
                        마진율: Math.round(마진율 * 10) / 10,
                        광고비, 순수익, 자연판매량, 광고판매량,
                        ROAS: Math.round(ROAS * 100) / 100,
                        ROI: Math.round(ROI * 10) / 10,
                        재고: currStock, 입고: 입고량, 재고조정, 공급가, 매입가, 판매가
                    };

                    dailyGrouped[currDate].products.push(productMetrics);

                    // 일별 합계
                    const day = dailyGrouped[currDate];
                    day.일별판매량 += 판매량;
                    day.일별공급매출 += 공급매출;
                    day.일별매입원가 += 매입원가;
                    day.일별마진 += 마진;
                    day.일별광고비 += 광고비;
                    day.일별순수익 += 순수익;
                    day.일별자연판매량 += 자연판매량;
                    day.일별광고판매량 += 광고판매량;
                    day.일별재고 += currStock;
                    day.일별입고 += 입고량;
                    day.일별재고조정 += 재고조정;
                });

                // 일별 ROAS/ROI 계산
                const day = dailyGrouped[currDate];
                if (day.일별광고비 > 0 && day.일별광고판매량 > 0) {
                    const avgPrice = day.일별공급매출 / Math.max(day.일별판매량, 1);
                    day.일별ROAS = Math.round((day.일별광고판매량 * avgPrice / day.일별광고비) * 100) / 100;
                }
                if (day.일별매입원가 > 0) {
                    day.일별ROI = Math.round((day.일별순수익 / (day.일별매입원가 * 10 / 11) * 100) * 10) / 10;
                }

                // 반올림
                ['일별판매량','일별공급매출','일별매입원가','일별마진','일별광고비','일별순수익','일별자연판매량','일별광고판매량']
                    .forEach(key => { day[key] = Math.round(day[key]); });
            }

            // 날짜 내림차순 정렬
            this.salesLedgerData = Object.values(dailyGrouped)
                .sort((a, b) => b.date.localeCompare(a.date));

            console.log('최종 일별 판매장부:', this.salesLedgerData.length, '일');

            // 상품별/차트/요약 생성
            this.generateProductViewData();
            this.generateChartData();
            this.generateProductChartData();
            this.calculateSummary();
        },

        // 상품별 보기용 데이터 생성 (growthSalesLedger.generateProductViewData 패턴)
        generateProductViewData() {
            const productGrouped = {};

            this.salesLedgerData.forEach(day => {
                day.products.forEach(product => {
                    const vid = product.vendorItemId;
                    if (!productGrouped[vid]) {
                        productGrouped[vid] = {
                            vendorItemId: vid, SKUID: product.SKUID,
                            상품명: product.상품명, 썸네일: product.썸네일,
                            판매량: 0, 공급매출: 0, 매입원가: 0, 마진: 0,
                            광고비: 0, 순수익: 0, 자연판매량: 0, 광고판매량: 0,
                            재고: 0, 입고: 0, 재고조정: 0, 공급가: product.공급가, 매입가: product.매입가,
                            dailyData: []
                        };
                    }
                    const g = productGrouped[vid];
                    g.판매량 += product.판매량 || 0;
                    g.공급매출 += product.공급매출 || 0;
                    g.매입원가 += product.매입원가 || 0;
                    g.마진 += product.마진 || 0;
                    g.광고비 += product.광고비 || 0;
                    g.순수익 += product.순수익 || 0;
                    g.자연판매량 += product.자연판매량 || 0;
                    g.광고판매량 += product.광고판매량 || 0;
                    g.입고 += product.입고 || 0;
                    g.재고조정 += product.재고조정 || 0;
                    g.재고 = product.재고; // 마지막 날짜의 재고
                    g.dailyData.push({ date: day.date, ...product });
                });
            });

            // 비율 계산 및 반올림
            Object.values(productGrouped).forEach(p => {
                const 단위마진 = (p.공급가 - p.매입가) * 10 / 11;
                p.마진율 = p.공급가 > 0 ? Math.round((단위마진 / p.공급가 * 100) * 10) / 10 : 0;
                p.광고매출 = Math.round(p.광고판매량 * 단위마진);
                p.광고순수익 = Math.round((p.광고판매량 * 단위마진) - (p.광고비 || 0));
                p.ROAS = p.광고비 > 0 ? Math.round((p.광고판매량 * p.공급가 / p.광고비) * 100) / 100 : 0;
                p.광고ROI = p.광고비 > 0 ? Math.round(((p.광고매출 - p.광고비) / p.광고비 * 100) * 10) / 10 : 0;
                p.ROI = p.매입원가 > 0 ? Math.round((p.순수익 / (p.매입원가 * 10 / 11) * 100) * 10) / 10 : 0;

                ['판매량','공급매출','매입원가','마진','광고비','순수익','자연판매량','광고판매량']
                    .forEach(key => { p[key] = Math.round(p[key]); });
            });

            this.productViewData = Object.values(productGrouped)
                .sort((a, b) => b.공급매출 - a.공급매출);
            console.log('상품별 보기 데이터:', this.productViewData.length, '개');
        },

        // 요약 데이터 계산 (7개 KPI 카드)
        calculateSummary() {
            const totalSupplyRevenue = this.salesLedgerData.reduce((s, d) => s + (d.일별공급매출 || 0), 0);
            const totalMargin = this.salesLedgerData.reduce((s, d) => s + (d.일별마진 || 0), 0);
            const totalAdCost = this.salesLedgerData.reduce((s, d) => s + (d.일별광고비 || 0), 0);
            const totalPurchase = this.salesLedgerData.reduce((s, d) => s + (d.일별매입원가 || 0), 0);
            const netProfit = this.salesLedgerData.reduce((s, d) => s + (d.일별순수익 || 0), 0);

            let totalAdRevenue = 0;
            this.salesLedgerData.forEach(day => {
                day.products.forEach(p => {
                    totalAdRevenue += (p.광고판매량 || 0) * (p.공급가 || 0);
                });
            });

            this.summary = {
                totalRevenue: totalSupplyRevenue,
                totalProfit: totalMargin,
                totalPurchase,
                totalAdCost,
                totalMarginRate: totalSupplyRevenue > 0 ? Math.round((totalMargin / totalSupplyRevenue) * 100) : 0,
                totalROAS: totalAdCost > 0 ? Math.round((totalAdRevenue / totalAdCost) * 100) : 0,
                totalROI: totalPurchase > 0 ? Math.round((netProfit / (totalPurchase * 10 / 11)) * 100) : 0,
                totalAdjust: this.salesLedgerData.reduce((s, d) => s + (d.일별재고조정 || 0), 0),
                adjustSkuCount: this.productViewData.filter(p => (p.재고조정 || 0) > 0).length
            };

            console.log('=== 로켓배송 판매장부 요약 ===');
            console.log('총공급매출:', totalSupplyRevenue.toLocaleString());
            console.log('총마진:', totalMargin.toLocaleString());
            console.log('총광고비:', totalAdCost.toLocaleString());
            console.log('순수익:', netProfit.toLocaleString());
        },

        // 일별 추이 차트 (공급매출 + 순수익 라인차트)
        generateChartData() {
            const chartData = this.salesLedgerData.map(day => ({
                date: day.date,
                공급매출: day.일별공급매출,
                순수익: day.일별순수익
            })).sort((a, b) => a.date.localeCompare(b.date));

            this.chartOptions = {
                chart: { type: 'line', height: 350, toolbar: { show: true }, background: 'transparent' },
                series: [
                    { name: '공급매출', type: 'line', data: chartData.map(i => i.공급매출), color: '#007bff' },
                    { name: '순수익', type: 'line', data: chartData.map(i => i.순수익), color: '#28a745' }
                ],
                xaxis: { categories: chartData.map(i => i.date), title: { text: '날짜' } },
                yaxis: {
                    title: { text: '금액 (원)' },
                    labels: { formatter: v => new Intl.NumberFormat('ko-KR').format(Math.round(v)) + '원' }
                },
                tooltip: { y: { formatter: v => new Intl.NumberFormat('ko-KR').format(Math.round(v)) + '원' } },
                stroke: { curve: 'smooth', width: 3 },
                markers: { size: 5 },
                legend: { position: 'top', horizontalAlign: 'left' }
            };
        },

        // 상품별 파레토 차트 (TOP 30)
        generateProductChartData() {
            if (!this.productViewData || this.productViewData.length === 0) return;

            const isProfit = this.productChartMode === 'profit' || this.productChartMode === true;
            const sorted = [...this.productViewData].sort((a, b) =>
                isProfit ? (b.마진 || 0) - (a.마진 || 0) : b.공급매출 - a.공급매출
            );
            const top30 = sorted.slice(0, 30);
            const categories = top30.map(p => {
                const name = p.상품명 || '';
                return name.length > 12 ? name.substring(0, 12) + '...' : name;
            });
            const baseData = top30.map(p => Math.round(isProfit ? (p.마진 || 0) : p.공급매출));
            const total = baseData.reduce((s, v) => s + v, 0);
            let cum = 0;
            const cumPct = baseData.map(v => { cum += v; return (cum / total) * 100; });

            const yTitle = isProfit ? '마진 (원)' : '공급매출 (원)';
            const sName = isProfit ? '마진' : '공급매출';

            this.productChartOptions = {
                chart: { type: 'line', height: 350, toolbar: { show: false } },
                plotOptions: { bar: { horizontal: false, columnWidth: '60%', endingShape: 'rounded' } },
                dataLabels: { enabled: false },
                stroke: { show: true, width: [0, 2], colors: ['transparent', '#ff6b6b'] },
                xaxis: { categories, labels: { rotate: -45, style: { fontSize: '9px' } } },
                yaxis: [
                    { title: { text: yTitle }, labels: { formatter: v => v ? v.toLocaleString() : '0' } },
                    { opposite: true, title: { text: '누적 비율 (%)' }, min: 0, max: 100, labels: { formatter: v => v.toFixed(0) + '%' } }
                ],
                fill: { opacity: [1, 1] },
                tooltip: {
                    shared: true, intersect: false,
                    y: [
                        { formatter: v => v ? v.toLocaleString() + '원' : '0원' },
                        { formatter: v => v.toFixed(1) + '%' }
                    ]
                },
                series: [
                    { name: sName, type: 'column', data: baseData, color: isProfit ? '#28a745' : '#007bff' },
                    { name: '누적 비율', type: 'line', yAxisIndex: 1, data: cumPct, color: '#ff6b6b' }
                ],
                legend: { position: 'top', horizontalAlign: 'center' }
            };
        },

        // 보기 모드 토글
        toggleView() {
            console.log('보기 모드 변경:', this.isProductView ? '상품별' : '일별');
            if (this.isProductView) {
                this.generateProductChartData();
            } else {
                this.generateChartData();
            }
        },

        // 날짜 클릭 시 해당 날짜의 상품별 상세 모달 표시
        showDateDetail(dateItem) {
            console.log('날짜 클릭:', dateItem);
            this.modalTitle = `${dateItem.date} 상품별 상세`;
            this.modalHeaders = this.productHeaders;

            this.modalData = (dateItem.products || []).map((product, index) => ({
                ...product,
                uniqueKey: `${dateItem.date}_${product.vendorItemId || 'unknown'}_${index}`,
            })).sort((a, b) => (b.공급매출 || 0) - (a.공급매출 || 0));

            this.generateModalProductChart(this.modalData);
            this.showModal = true;
        },

        // 상품 클릭 시 해당 상품의 일별 상세 모달 표시
        showProductDetail(productItem) {
            console.log('상품 클릭:', productItem);
            this.modalTitle = `${productItem.상품명} 일별 상세`;
            this.dailyChartMode = 'amount';

            this.modalHeaders = [
                { text: '날짜', value: 'date', align: 'center', width: 120 },
                ...this.productHeaders.filter(h =>
                    !['썸네일', '상품명', 'vendorItemId'].includes(h.value)
                )
            ];

            this.modalData = (productItem.dailyData || []).map((item, index) => ({
                ...item,
                uniqueKey: `${item.date}_${productItem.vendorItemId}_${index}`,
            })).sort((a, b) => b.date.localeCompare(a.date));

            this.generateModalDailyChart(this.modalData);
            this.showModal = true;
        },

        // 일별 차트 모드 변경 시 차트 업데이트
        updateDailyChart() {
            this.generateModalDailyChart(this.modalData);
        },

        // 모달 상품별 파레토 차트 생성
        generateModalProductChart(products) {
            this.showModalChart = false;
            if (!products || products.length === 0) return;

            const top50 = products.slice(0, 50);
            const categories = top50.map(p => {
                const name = p.상품명 || '';
                return name.length > 8 ? name.substring(0, 8) + '...' : name;
            });
            const saleData = top50.map(p => Math.round(p.공급매출 || 0));
            const total = saleData.reduce((s, v) => s + v, 0);
            let cum = 0;
            const cumPct = saleData.map(v => { cum += v; return total > 0 ? (cum / total) * 100 : 0; });

            this.modalChartOptions = {
                chart: { type: 'line', height: 400, width: '100%', toolbar: { show: false } },
                plotOptions: { bar: { horizontal: false, columnWidth: '70%', endingShape: 'rounded' } },
                dataLabels: { enabled: false },
                stroke: { show: true, width: [0, 2], colors: ['transparent', '#ff6b6b'] },
                xaxis: { categories, labels: { rotate: -45, style: { fontSize: '8px' }, maxHeight: 80 } },
                yaxis: [
                    { title: { text: '공급매출 (원)' }, labels: { formatter: v => v ? v.toLocaleString() : '0' } },
                    { opposite: true, title: { text: '누적 비율 (%)' }, min: 0, max: 100, labels: { formatter: v => v.toFixed(0) + '%' } }
                ],
                fill: { opacity: [1, 1] },
                tooltip: { shared: true, intersect: false, y: [
                    { formatter: v => v ? v.toLocaleString() + '원' : '0원' },
                    { formatter: v => v.toFixed(1) + '%' }
                ]},
                series: [
                    { name: '공급매출', type: 'column', data: saleData, color: '#007bff' },
                    { name: '누적 비율', type: 'line', yAxisIndex: 1, data: cumPct, color: '#ff6b6b' }
                ],
                legend: { position: 'top', horizontalAlign: 'center' }
            };
            setTimeout(() => { this.showModalChart = true; }, 100);
        },

        // 모달 일자별 지표 차트 생성 (금액/수량 모드 토글)
        generateModalDailyChart(dailyData) {
            this.showModalChart = false;
            if (!dailyData || dailyData.length === 0) return;

            const sorted = [...dailyData].sort((a, b) => a.date.localeCompare(b.date));
            const categories = sorted.map(i => i.date);

            if (this.dailyChartMode === 'amount') {
                this.modalChartOptions = {
                    chart: { type: 'line', height: 400, width: '100%', toolbar: { show: false } },
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 2 },
                    xaxis: { categories, labels: { rotate: -45, style: { fontSize: '9px' } } },
                    yaxis: { title: { text: '금액 (원)' }, labels: { formatter: v => v ? v.toLocaleString() : '0' } },
                    tooltip: { shared: true, intersect: false, y: { formatter: v => v ? v.toLocaleString() + '원' : '0원' } },
                    series: [
                        { name: '공급매출', data: sorted.map(i => Math.round(i.공급매출 || 0)), color: '#007bff' },
                        { name: '순수익', data: sorted.map(i => Math.round(i.순수익 || 0)), color: '#28a745' },
                        { name: '광고비', data: sorted.map(i => Math.round(i.광고비 || 0)), color: '#ffc107' }
                    ],
                    legend: { position: 'top', horizontalAlign: 'center' }
                };
            } else {
                this.modalChartOptions = {
                    chart: { type: 'line', height: 400, width: '100%', toolbar: { show: false } },
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 2 },
                    xaxis: { categories, labels: { rotate: -45, style: { fontSize: '9px' } } },
                    yaxis: { title: { text: '수량 (개)' }, labels: { formatter: v => v ? v.toLocaleString() : '0' } },
                    tooltip: { shared: true, intersect: false, y: { formatter: v => v ? v.toLocaleString() + '개' : '0개' } },
                    series: [
                        { name: '판매량', data: sorted.map(i => i.판매량 || 0), color: '#007bff' },
                        { name: '자연판매량', data: sorted.map(i => i.자연판매량 || 0), color: '#28a745' },
                        { name: '광고판매량', data: sorted.map(i => i.광고판매량 || 0), color: '#ffc107' }
                    ],
                    legend: { position: 'top', horizontalAlign: 'center' }
                };
            }
            setTimeout(() => { this.showModalChart = true; }, 100);
        },

        // 모달 스타일 강제 적용
        forceModalStyle() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const modal = document.querySelector('.rocket-sales-ledger-modal .modal-dialog');
                    const modalContent = document.querySelector('.rocket-sales-ledger-modal .modal-content');
                    const modalBody = document.querySelector('.rocket-sales-ledger-modal .modal-body');

                    if (modal) {
                        modal.style.maxWidth = '98vw';
                        modal.style.width = '98vw';
                        modal.style.height = '96vh';
                        modal.style.maxHeight = '96vh';
                        modal.style.margin = '1vh auto';
                    }

                    if (modalContent) {
                        modalContent.style.height = '100%';
                        modalContent.style.display = 'flex';
                        modalContent.style.flexDirection = 'column';
                        modalContent.style.border = 'none';
                        modalContent.style.borderRadius = '0';
                    }

                    if (modalBody) {
                        modalBody.style.flex = '1';
                        modalBody.style.overflowY = 'auto';
                        modalBody.style.padding = '0.5rem';
                        modalBody.style.maxHeight = 'none';
                    }

                    console.log('로켓배송 판매장부 모달 스타일 강제 적용 완료');
                }, 100);
            });
        },

        // 엑셀 다운로드 - 일별 테이블
        downloadDailyTableExcel() {
            try {
                if (!this.salesLedgerData || this.salesLedgerData.length === 0) {
                    alert('다운로드할 데이터가 없습니다.');
                    return;
                }

                const excelData = this.salesLedgerData.map(item => {
                    const row = {};
                    this.dailyHeaders.forEach(header => {
                        const key = header.value;
                        let value = item[key];
                        if (typeof value === 'number') {
                            row[header.text] = value;
                        } else {
                            row[header.text] = value || '';
                        }
                    });
                    return row;
                });

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, '일별 판매장부');
                XLSX.writeFile(wb, `로켓배송판매장부_일별_${this.startDate}_${this.endDate}.xlsx`);
            } catch (error) {
                console.error('일별 테이블 엑셀 다운로드 오류:', error);
                alert('엑셀 다운로드 중 오류가 발생했습니다.');
            }
        },

        // 엑셀 다운로드 - 상품별 테이블
        downloadProductTableExcel() {
            try {
                if (!this.productViewData || this.productViewData.length === 0) {
                    alert('다운로드할 데이터가 없습니다.');
                    return;
                }

                const excelData = this.productViewData.map(item => {
                    const row = {};
                    this.productHeaders.forEach(header => {
                        const key = header.value;
                        let value = item[key];
                        if (key === '썸네일') {
                            row[header.text] = item.썸네일 || '';
                        } else if (typeof value === 'number') {
                            row[header.text] = value;
                        } else {
                            row[header.text] = value || '';
                        }
                    });
                    return row;
                });

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, '상품별 판매장부');
                XLSX.writeFile(wb, `로켓배송판매장부_상품별_${this.startDate}_${this.endDate}.xlsx`);
            } catch (error) {
                console.error('상품별 테이블 엑셀 다운로드 오류:', error);
                alert('엑셀 다운로드 중 오류가 발생했습니다.');
            }
        },

        // 엑셀 다운로드 - 모달 테이블
        downloadModalTableExcel() {
            try {
                if (!this.modalData || this.modalData.length === 0) {
                    alert('다운로드할 데이터가 없습니다.');
                    return;
                }

                const excelData = this.modalData.map(item => {
                    const row = {};
                    this.modalHeaders.forEach(header => {
                        const key = header.value;
                        let value = item[key];
                        if (typeof value === 'number') {
                            row[header.text] = value;
                        } else {
                            row[header.text] = value || '';
                        }
                    });
                    return row;
                });

                let filename;
                let sheetName;
                if (this.isProductView) {
                    const productName = this.modalData[0]?.상품명 || '상품상세';
                    const safeProductName = productName.replace(/[<>:"/\\|?*]/g, '_').substring(0, 50);
                    filename = `로켓배송판매장부_상품별상세_${safeProductName}_${this.startDate}_${this.endDate}.xlsx`;
                    sheetName = '상품별 상세';
                } else {
                    const selectedDate = this.modalTitle.includes('상세') ? this.modalTitle.split(' ')[0] : this.startDate;
                    filename = `로켓배송판매장부_일별상세_${selectedDate}.xlsx`;
                    sheetName = '일별 상세';
                }

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, sheetName);
                XLSX.writeFile(wb, filename);
            } catch (error) {
                console.error('모달 테이블 엑셀 다운로드 오류:', error);
                alert('엑셀 다운로드 중 오류가 발생했습니다.');
            }
        },

        // 숫자 포맷팅
        formatNumber(num) {
            if (num === null || num === undefined || isNaN(num)) return 0;
            return Math.round(num).toLocaleString();
        }
    }
}
</script>

<style scoped>
/* 로켓배송 판매장부 모달 크기 고정 */
::v-deep .rocket-sales-ledger-modal .modal-dialog {
    max-width: 98vw !important;
    width: 98vw !important;
    height: 96vh !important;
    max-height: 96vh !important;
    margin: 1vh auto !important;
}

::v-deep .rocket-sales-ledger-modal .modal-content {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    border: none !important;
    border-radius: 0 !important;
}

::v-deep .rocket-sales-ledger-modal .modal-header {
    padding: 0.5rem 1rem !important;
    border-bottom: 1px solid #dee2e6 !important;
    flex-shrink: 0 !important;
}

::v-deep .rocket-sales-ledger-modal .modal-body {
    flex: 1 !important;
    overflow-y: auto !important;
    padding: 0.5rem !important;
    max-height: none !important;
}

::v-deep .rocket-sales-ledger-modal .modal-footer {
    padding: 0.5rem 1rem !important;
    border-top: 1px solid #dee2e6 !important;
    flex-shrink: 0 !important;
}
</style>
